<template>
    <b-container class="hkiarace-event-category-add">
        <b-row>
            <b-col>
                <h2>{{$t('admin_event_category.add_category')}}</h2>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col>
                <b-form class="hkiarace-event-category-add-form">
                    <b-form-group :label="$t('admin_event_category.name_en')"
                                  horizontal>
                        <b-form-input v-model="name_en"></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('admin_event_category.name_zh')"
                                  horizontal>
                        <b-form-input v-model="name_zh"></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('admin_event_category.color')"
                                  horizontal>
                        <swatches-picker :value="color" @input="colorSelected"></swatches-picker>
                    </b-form-group>

                    <b-form-group :label="$t('admin_event_category.layout_style')" horizontal>
                        <b-form-radio-group v-model="layout_style">
                            <b-form-radio :value="1">{{$t('admin_event_category.layout_style_list')}}</b-form-radio>
                            <b-form-radio :value="2">{{$t('admin_event_category.layout_style_grid')}}</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-form>


                <b-button id="saveEventCategoryBtn" @click="saveEventCategory" variant="primary">{{$t('save')}}</b-button>
                <b-button @click="cancel">{{$t('cancel')}}</b-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEdit, faSearch} from '@fortawesome/free-solid-svg-icons'
    import {Swatches} from 'vue-color'

    library.add(faEdit, faSearch);

    export default {
        name: 'EventCategoryAdd',
        components: {
            'swatches-picker': Swatches,
        },
        data() {
            return {
                name_en: "",
                name_zh: "",
                color: "",
                layout_style: "",
            }
        },
        computed: {},
        methods: {
            colorSelected(color) {
                this.color = color.hex;
            },
            saveEventCategory() {
                if (!this.name_en) {
                    this.$showAlertMessage("Please input all fields");
                    return;
                }

                this.$callAPI('hkiarace/event_category/create/', {
                    name_en: this.name_en,
                    name_zh: this.name_zh,
                    color: this.color,
                    layout_style: this.layout_style,
                }, function (response) {
                    this.$router.back();
                })
            },
            cancel() {
                this.$router.back();
            },
        },
    }
</script>

<style scoped lang="less">
    #saveEventCategoryBtn {
        margin-right: 15px;
    }
</style>
